import React, { useEffect, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { Controller } from "react-hook-form";
import FormSimple from "@components/formGroup/formSimple";
import InputWithAddOptions from "@components/input/InputWithAddOptions";
import { checkEnterpriseId } from "@helpers/_functions";
import { insuranceAndCoverageActions } from "@store/actions/settings/_insuranceNumberAndCoverageTypeActions";
import useInsuranceAndCoverageType from "@pages/shared/employeFormNew/JobAndSalary/SharedInformationBanking/helpers/_functions";
// import {
//   REGEX_ACCOUNT_NUMBER,
//   REGEX_POST_NUMBER,
//   REGEX_SOCIAL_NUMBER,
//   REGEX_TRANSIT_NUMBER,
//   REGEX_PLAN_NUMBER_CERTIFICATE_MEMBER
// } from "@helpers/_constants";

export const useSectionInsuranceBankingColumns = () => {
  const { t } = useTranslation("pages.employés.emploi&Salary");

  return useMemo(() => [
    { id: "transitNumber", label: t("Numéro de transit") },
    { id: "institutionNumber", label: t("Numéro d'institution") },
    { id: "accountNumber", label: t("Numéro de compte") },
    { id: "socialInsuranceNumber", label: t("Numéro d'assurance sociale") },
    { id: "planNumber", label: t("Numéro de régime") },
    { id: "memberCertificateNumber", label: t("Numéro de certificat d'adhérent") },
    { id: "insurancePlanNumber", label: t("Numéro de plan d'assurance") },
    { id: "typeCover", label: t("Type de couverture") }
  ], [t])
}

export const SectionInsuranceBankingTableBulkHeader = ({ hiddenColumns = {} }) => {
  const { t: mainTranslator } = useTranslation("pages.employés.emploi&Salary");

  return (
    <>
      <th
        key="transitNumber"
        className={`arh-w-[12.5rem] arh-min-w-[12.5rem] arh-bg-greyColor arh-px-5 arh-py-[10px] arh-align-bottom arh-text-xs arh-font-semibold arh-text-darkColor ${hiddenColumns.transitNumber ? "arh-hidden" : ""}`}
      >
        {mainTranslator("Numéro de transit")}
      </th>
      <th
        key="institutionNumber"
        className={`arh-w-[12.5rem] arh-min-w-[12.5rem] arh-bg-greyColor arh-px-5 arh-py-[10px] arh-align-bottom arh-text-xs arh-font-semibold arh-text-darkColor ${hiddenColumns.institutionNumber ? "arh-hidden" : ""}`}
      >
        {mainTranslator("Numéro d'institution")}
      </th>
      <th
        key="accountNumber"
        className={`arh-w-[12.5rem] arh-min-w-[12.5rem] arh-bg-greyColor arh-px-5 arh-py-[10px] arh-align-bottom arh-text-xs arh-font-semibold arh-text-darkColor ${hiddenColumns.accountNumber ? "arh-hidden" : ""}`}
      >
        {mainTranslator("Numéro de compte")}
      </th>
      <th
        key="socialInsuranceNumber"
        className={`arh-w-[12.5rem] arh-min-w-[12.5rem] arh-bg-greyColor arh-px-5 arh-py-[10px] arh-align-bottom arh-text-xs arh-font-semibold arh-text-darkColor ${hiddenColumns.socialInsuranceNumber ? "arh-hidden" : ""}`}
      >
        {mainTranslator("Numéro d'assurance sociale")}
      </th>
      <th
        key="planNumber"
        className={`arh-w-[12.5rem] arh-min-w-[12.5rem] arh-bg-greyColor arh-px-5 arh-py-[10px] arh-align-bottom arh-text-xs arh-font-semibold arh-text-darkColor ${hiddenColumns.planNumber ? "arh-hidden" : ""}`}
      >
        {mainTranslator("Numéro de régime")}
      </th>
      <th
        key="memberCertificateNumber"
        className={`arh-w-[12.5rem] arh-min-w-[12.5rem] arh-bg-greyColor arh-px-5 arh-py-[10px] arh-align-bottom arh-text-xs arh-font-semibold arh-text-darkColor ${hiddenColumns.memberCertificateNumber ? "arh-hidden" : ""}`}
      >
        {mainTranslator("Numéro de certificat d'adhérent")}
      </th>
      <th
        key="insurancePlanNumber"
        className={`arh-w-[12.5rem] arh-min-w-[12.5rem] arh-bg-greyColor arh-px-5 arh-py-[10px] arh-align-bottom arh-text-xs arh-font-semibold arh-text-darkColor ${hiddenColumns.insurancePlanNumber ? "arh-hidden" : ""}`}
      >
        {mainTranslator("Numéro de plan d'assurance")}
      </th>
      <th
        key="typeCover"
        className={`arh-w-[12.5rem] arh-min-w-[12.5rem] arh-max-w-[12.5rem] arh-bg-greyColor arh-px-5 arh-py-[10px] arh-align-bottom arh-text-xs arh-font-semibold arh-text-darkColor ${hiddenColumns.typeCover ? "arh-hidden" : ""}`}
      >
        {mainTranslator("Type de couverture")}
      </th>
    </>
  );
};

export const SectionInsuranceBankingTableBulkCells = ({ 
  control, 
  employeeIndex, 
  employee, 
  readOnly = false, 
  mustWait,
  getValues,
  isActiveBankingInformationAndInsuranceAccess,
  hiddenColumns = {}
}) => {
  const { t: mainTranslator } = useTranslation("pages.employés.emploi&Salary");
  const reduxDispatch = useDispatch();

  const {
    insurancePlanNumberList,
    coverageTypeList,
    addInsurancePlanNumber,
    deleteInsurancePlanNumber,
    addCoverageType,
    deleteCoverageType,
  } = useInsuranceAndCoverageType();

  useEffect(() => {
    reduxDispatch(insuranceAndCoverageActions.loadData);
  }, [reduxDispatch]);

  // const makeTransitNumberRule = useCallback(() => {
  //   return {
  //     validate: {
  //       required: (value) => {
  //         const isSelected = getValues(`employees.${employeeIndex}.selected`);
  //         if (!isSelected) return true;
          
  //         return value === "" || REGEX_TRANSIT_NUMBER.test(value);
  //       }
  //     }
  //   };
  // }, [getValues, employeeIndex]);

  // const makeInstitutionNumberRule = useCallback(() => {
  //   return {
  //     validate: {
  //       required: (value) => {
  //         const isSelected = getValues(`employees.${employeeIndex}.selected`);
  //         if (!isSelected) return true;
          
  //         return value === "" || REGEX_POST_NUMBER.test(value);
  //       }
  //     }
  //   };
  // }, [getValues, employeeIndex]);

  // const makeAccountNumberRule = useCallback(() => {
  //   return {
  //     validate: {
  //       required: (value) => {
  //         const isSelected = getValues(`employees.${employeeIndex}.selected`);
  //         if (!isSelected) return true;
          
  //         return value === "" || REGEX_ACCOUNT_NUMBER.test(value);
  //       }
  //     }
  //   };
  // }, [getValues, employeeIndex]);

  // const makeSocialInsuranceRule = useCallback(() => {
  //   return {
  //     validate: {
  //       required: (value) => {
  //         const isSelected = getValues(`employees.${employeeIndex}.selected`);
  //         if (!isSelected) return true;
          
  //         return value === "" || REGEX_SOCIAL_NUMBER.test(value);
  //       }
  //     }
  //   };
  // }, [getValues, employeeIndex]);

  // const makePlanNumberRule = useCallback(() => {
  //   return {
  //     validate: {
  //       required: (value) => {
  //         const isSelected = getValues(`employees.${employeeIndex}.selected`);
  //         if (!isSelected) return true;
          
  //         return value === "" || REGEX_PLAN_NUMBER_CERTIFICATE_MEMBER.test(value);
  //       }
  //     }
  //   };
  // }, [getValues, employeeIndex]);

  // const makeMemberCertificateRule = useCallback(() => {
  //   return {
  //     validate: {
  //       required: (value) => {
  //         const isSelected = getValues(`employees.${employeeIndex}.selected`);
  //         if (!isSelected) return true;
          
  //         return value === "" || REGEX_PLAN_NUMBER_CERTIFICATE_MEMBER.test(value);
  //       }
  //     }
  //   };
  // }, [getValues, employeeIndex]);

  return (
    <>
      <td
        key="transitNumber"
        className={`arh-w-[12.5rem] arh-min-w-[12.5rem] arh-p-4 arh-px-5 arh-font-poppins arh-text-xs arh-text-darkGreyColor ${hiddenColumns.transitNumber ? "arh-hidden" : ""}`}
      >
        <Controller
          control={control}
          name={`employees.${employeeIndex}.emploiSalary.BankingAndInsuranceInformation.transitNumber`}
          defaultValue={employee.emploiSalary.BankingAndInsuranceInformation?.transitNumber || ""}
          // rules={makeTransitNumberRule()}
          render={({ field: { onChange, value } }) => (
            <FormSimple
              placeholder="00000"
              value={!isActiveBankingInformationAndInsuranceAccess ? "-" : value}
              onChange={onChange}
              classInput={`!arh-py-[5px] !arh-px-2.5 ${!isActiveBankingInformationAndInsuranceAccess ? "arh-text-center" : ""
                }`}
              readOnly={mustWait || !isActiveBankingInformationAndInsuranceAccess || readOnly}
              edit={true}
              // invalid={invalid}
            />
          )}
        />
      </td>
      <td
        key="institutionNumber"
        className={`arh-w-[12.5rem] arh-min-w-[12.5rem] arh-p-4 arh-px-5 arh-font-poppins arh-text-xs arh-text-darkGreyColor ${hiddenColumns.institutionNumber ? "arh-hidden" : ""}`}
      >
        <Controller
          control={control}
          name={`employees.${employeeIndex}.emploiSalary.BankingAndInsuranceInformation.institutionNumber`}
          defaultValue={employee.emploiSalary.BankingAndInsuranceInformation?.institutionNumber || ""}
          // rules={makeInstitutionNumberRule()}
          render={({ field: { onChange, value } }) => (
            <FormSimple
              placeholder="000"
              value={!isActiveBankingInformationAndInsuranceAccess ? "-" : value}
              onChange={onChange}
              classInput={`!arh-py-[5px] !arh-px-2.5 ${!isActiveBankingInformationAndInsuranceAccess ? "arh-text-center" : ""
                }`}
              readOnly={mustWait || !isActiveBankingInformationAndInsuranceAccess || readOnly}
              edit={true}
              // invalid={invalid}
            />
          )}
        />
      </td>
      <td
        key="accountNumber"
        className={`arh-w-[12.5rem] arh-min-w-[12.5rem] arh-p-4 arh-px-5 arh-font-poppins arh-text-xs arh-text-darkGreyColor ${hiddenColumns.accountNumber ? "arh-hidden" : ""}`}
      >
        <Controller
          control={control}
          name={`employees.${employeeIndex}.emploiSalary.BankingAndInsuranceInformation.accountNumber`}
          defaultValue={employee.emploiSalary.BankingAndInsuranceInformation?.accountNumber || ""}
          // rules={makeAccountNumberRule()}
          render={({ field: { onChange, value } }) => (
            <FormSimple
              placeholder="000000000000"
              value={!isActiveBankingInformationAndInsuranceAccess ? "-" : value}
              onChange={onChange}
              classInput={`!arh-py-[5px] !arh-px-2.5 ${!isActiveBankingInformationAndInsuranceAccess ? "arh-text-center" : ""
                }`}
              readOnly={mustWait || !isActiveBankingInformationAndInsuranceAccess || readOnly}
              edit={true}
              // invalid={invalid}
            />
          )}
        />
      </td>
      <td
        key="socialInsuranceNumber"
        className={`arh-w-[12.5rem] arh-min-w-[12.5rem] arh-p-4 arh-px-5 arh-font-poppins arh-text-xs arh-text-darkGreyColor ${hiddenColumns.socialInsuranceNumber ? "arh-hidden" : ""}`}
      >
        <Controller
          control={control}
          name={`employees.${employeeIndex}.emploiSalary.BankingAndInsuranceInformation.socialInsuranceNumber`}
          defaultValue={employee.emploiSalary.BankingAndInsuranceInformation?.socialInsuranceNumber || ""}
          // rules={makeSocialInsuranceRule()}
          render={({ field: { onChange, value } }) => (
            <FormSimple
              placeholder="000000000"
              value={!isActiveBankingInformationAndInsuranceAccess ? "-" : value}
              onChange={onChange}
              classInput={`!arh-py-[5px] !arh-px-2.5 ${!isActiveBankingInformationAndInsuranceAccess ? "arh-text-center" : ""
                }`}
              readOnly={mustWait || !isActiveBankingInformationAndInsuranceAccess || readOnly}
              edit={true}
              // invalid={invalid}
            />
          )}
        />
      </td>
      <td
        key="planNumber"
        className={`arh-w-[12.5rem] arh-min-w-[12.5rem] arh-p-4 arh-px-5 arh-font-poppins arh-text-xs arh-text-darkGreyColor ${hiddenColumns.planNumber ? "arh-hidden" : ""}`}
      >
        <Controller
          control={control}
          name={`employees.${employeeIndex}.emploiSalary.BankingAndInsuranceInformation.planNumber`}
          defaultValue={employee.emploiSalary.BankingAndInsuranceInformation?.planNumber || ""}
          // rules={makePlanNumberRule()}
          render={({ field: { onChange, value } }) => (
            <FormSimple
              placeholder="00000"
              value={!isActiveBankingInformationAndInsuranceAccess ? "-" : value}
              onChange={onChange}
              classInput={`!arh-py-[5px] !arh-px-2.5 ${!isActiveBankingInformationAndInsuranceAccess ? "arh-text-center" : ""
                }`}
              readOnly={mustWait || !isActiveBankingInformationAndInsuranceAccess || readOnly}
              edit={true}
              // invalid={invalid}
            />
          )}
        />
      </td>
      <td
        key="memberCertificateNumber"
        className={`arh-w-[12.5rem] arh-min-w-[12.5rem] arh-p-4 arh-px-5 arh-font-poppins arh-text-xs arh-text-darkGreyColor ${hiddenColumns.memberCertificateNumber ? "arh-hidden" : ""}`}
      >
        <Controller
          control={control}
          name={`employees.${employeeIndex}.emploiSalary.BankingAndInsuranceInformation.memberCertificateNumber`}
          defaultValue={employee.emploiSalary.BankingAndInsuranceInformation?.memberCertificateNumber || ""}
          // rules={makeMemberCertificateRule()}
          render={({ field: { onChange, value } }) => (
            <FormSimple
              placeholder="00000"
              value={!isActiveBankingInformationAndInsuranceAccess ? "-" : value}
              onChange={onChange}
              classInput={`!arh-py-[5px] !arh-px-2.5 ${!isActiveBankingInformationAndInsuranceAccess ? "arh-text-center" : ""
                }`}
              readOnly={mustWait || !isActiveBankingInformationAndInsuranceAccess || readOnly}
              edit={true}
              // invalid={invalid}
            />
          )}
        />
      </td>
      <td
        key="insurancePlanNumber"
        className={`arh-w-[12.5rem] arh-min-w-[12.5rem] arh-p-4 arh-px-5 arh-font-poppins arh-text-xs arh-text-darkGreyColor ${hiddenColumns.insurancePlanNumber ? "arh-hidden" : ""}`}
      >
        <div className="arh-flex arh-flex-col">
          <Controller
            control={control}
            name={`employees.${employeeIndex}.emploiSalary.BankingAndInsuranceInformation.insurancePlanNumber`}
            defaultValue={employee.emploiSalary.BankingAndInsuranceInformation?.insurancePlanNumber || ""}
            render={({ field: { onChange, value, name } }) => (
              <InputWithAddOptions
                defaultText="00000"
                name={name}
                optionsList={insurancePlanNumberList || []}
                secondDefaultText={mainTranslator("Ajouter")}
                value={!isActiveBankingInformationAndInsuranceAccess ? "-" : value}
                optionListLabel="name"
                onChange={(event) => {
                  onChange(event?.target?.dataset.value || null);
                }}
                addItem={(data) =>
                  addInsurancePlanNumber({
                    ...data,
                    entreprise: checkEnterpriseId(),
                  })
                }
                deleteItem={deleteInsurancePlanNumber}
                showAction
                disabled={mustWait || !isActiveBankingInformationAndInsuranceAccess || readOnly}
                classInput={`!arh-py-[5px] !arh-px-2.5 !arh-pr-8 arh-truncate arh-whitespace-nowrap arh-overflow-hidden ${!isActiveBankingInformationAndInsuranceAccess ? "arh-text-center" : ""
                }`}
                classBtn="arh-absolute arh-right-1 arh-top-1/2 -arh-translate-y-1/2 !arh-py-[0.0625rem] !arh-px-2.5"
              />
            )}
          />
        </div>
      </td>
      <td
        key="typeCover"
        className={`arh-w-[12.5rem] arh-min-w-[12.5rem] arh-max-w-[12.5rem] arh-p-4 arh-px-5 arh-font-poppins arh-text-xs arh-text-darkGreyColor ${hiddenColumns.typeCover ? "arh-hidden" : ""}`}
      >
        <div className="arh-flex arh-flex-col">
          <Controller
            control={control}
            name={`employees.${employeeIndex}.emploiSalary.BankingAndInsuranceInformation.typeCover`}
            defaultValue={employee.emploiSalary.BankingAndInsuranceInformation?.typeCover || ""}
            render={({ field: { onChange, value, name } }) => (
              <InputWithAddOptions
                defaultText="00000"
                name={name}
                optionsList={coverageTypeList || []}
                secondDefaultText={mainTranslator("Ajouter")}
                value={!isActiveBankingInformationAndInsuranceAccess ? "-" : value}
                optionListLabel="name"
                onChange={(event) => {
                  onChange(event?.target?.dataset.value || null);
                }}
                addItem={(data) =>
                  addCoverageType({
                    ...data,
                    entreprise: checkEnterpriseId(),
                  })
                }
                deleteItem={deleteCoverageType}
                showAction
                disabled={mustWait || !isActiveBankingInformationAndInsuranceAccess || readOnly}
                classInput={`!arh-py-[5px] !arh-px-2.5 !arh-pr-8 arh-truncate arh-whitespace-nowrap arh-overflow-hidden ${!isActiveBankingInformationAndInsuranceAccess ? "arh-text-center" : ""
                }`}
                classBtn="arh-absolute arh-right-1 arh-top-1/2 -arh-translate-y-1/2 !arh-py-[0.0625rem] !arh-px-2.5"
              />
            )}
          />
        </div>
      </td>
    </>
  );
};

export const getInsuranceBankingColumnCount = () => 8;